import Spacer from '@/common/components/spacer';
import { CopyNode } from '@/homepage/constants/car-ownership-reimagined';
import FlexcarWordmark2024 from '@/icons/flexcar-wordmark-2024';
import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';

interface FlexcarIsTileProps {
  title: string;
  copy: CopyNode[];
  gridCols: 1 | 2;
  className?: string;
}

export default function FlexcarIsTile({
  title,
  gridCols,
  copy,
  className,
}: FlexcarIsTileProps) {
  return (
    <div
      className={cn(
        'relative flex aspect-square h-full min-h-[392px] w-full flex-1 flex-col items-center justify-start rounded-[16px] border-[2px] border-solid border-transparent p-[24px]',
        className
      )}
      style={{
        // This allows us to achieve a gradient border, which is not valid css. We set a 2px transparent border, a padding box background color, then a gradient around it
        background: `linear-gradient(${colors.neutral100}, ${colors.neutral100}) padding-box, linear-gradient(45deg, ${colors.sunsetBlue} 0%, ${colors.sunsetPurple} 50%, #E6D2EA 100%) border-box`,
      }}
    >
      <FlexcarWordmark2024
        className="h-[20px] w-[58px] flex-shrink-0"
        fillPrimary={colors.aqua40}
      />
      <Spacer variant="height4" />
      <h1 className="font-[24px] text-flexcar-blue30">{title}</h1>
      <Spacer variant="height24" />
      <div
        className={cn(`grid gap-x-0 gap-y-[32px]`, {
          'grid-cols-2': gridCols === 2,
          'grid-cols-1': gridCols === 1,
        })}
      >
        {copy.map((c, index) => (
          <div key={index} className="col-span-1 flex flex-col items-center gap-[16px]">
            {c.icon}
            <p className="body2-strong text-center text-flexcar-neutral1">{c.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
